import { IntegrationWithJobInfo, getNetsuiteLocations } from "@/api/integration"
import { CreditMemoLocationSettings } from "./credit-memo-location-settings"

interface NetsuiteLocationSettingsProps {
  integration: IntegrationWithJobInfo
}

/**
 * Lets the user pick the Location stamped on credit memos created when applying cash. Required when
 * the NetSuite account enables "Make Locations Mandatory" (Setup > Accounting > Accounting
 * Preferences) — without it, credit memo creates fail with "Please enter value(s) for: Location."
 */
export function NetsuiteLocationSettings({ integration }: NetsuiteLocationSettingsProps) {
  return (
    <CreditMemoLocationSettings
      integration={integration}
      description='If your NetSuite account requires a Location on transactions ("Make Locations Mandatory"), choose the location to stamp on credit memos created when applying cash. Leave unset otherwise.'
      none_label="None (locations not required)"
      fetch_locations={getNetsuiteLocations}
    />
  )
}
